import axios from "axios";
import Log from "~/modules/log";

export default class Cookie {
  static acceptCookies ( callback ) {
    axios.post( "/umbraco/Surface/CookiesSurface/AcceptCookies" )
      .then( response => {
        if ( response.data.Response ) {
          Log.debug( "Cookies accepted successfully", null, "cookie" );
        } else {
          Log.error( "Error accepted cookies", response.data.ErrorMessage, "cookie" );
        }
      } )
      .catch( error => {
        Log.error( "Error accepted cookies", error, "cookie" );
      } );

    if ( callback ) {
      callback();
    }
  }

  static denyCookies ( callback ) {
    axios.post( "/umbraco/Surface/CookiesSurface/DenyCookies" )
      .then( response => {
        if ( response.data.Response ) {
          Log.debug( "Cookies denied successfully", null, "cookie" );
        } else {
          Log.error( "Error denying cookies", response.data.ErrorMessage, "cookie" );
        }
      } )
      .catch( error => {
        Log.error( "Error denying cookies", error, "cookie" );
      } );

    if ( callback ) {
      callback();
    }
  }
}
